var gallery = require('../../vendors/baguettebox.js/src/baguettebox.js');

class Realizzazioni {

	constructor() {

		gallery.run('.realizzazione-gallery');
		gallery.run('.sistemi-gallery');

	}

}

module.exports = new Realizzazioni;


/** WEBPACK FOOTER **
 ** ./layouts/realizzazioni.js
 **/